var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page",class:_vm.isLoading ? 'loading-visible' : 'loading-hidden'},[_c('iframe',{attrs:{"src":"/loading.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }